/**
 * Masterlisten-Export (Admin Einstellungen → Export).
 *
 * Portierung des Import/Export-Bereichs aus CRM 1.0. Der Export läuft
 * asynchron: POST reiht einen Queue-Job ein und legt sofort einen Eintrag mit
 * status='processing' an; die Liste wird gepollt, bis 'finished' (Download)
 * oder 'failed' erscheint.
 *
 *   POST /v2/admin/exports/cares          { year, only_active } → 202
 *   GET  /v2/admin/exports                → { data: ExportFile[] }
 *   GET  /v2/admin/exports/{id}/download  → XLSX-Blob
 */
import { apiV2 } from './api';

export interface ExportFile {
  id: number;
  file: string;
  status: 'processing' | 'finished' | 'failed';
  created_at: string | null;
}

export const exportsApi = {
  list: async (): Promise<ExportFile[]> => {
    const res = await apiV2.get<{ data: ExportFile[] }>('/admin/exports');
    return res.data.data;
  },

  startCares: async (year: number, onlyActive: boolean): Promise<ExportFile> => {
    const res = await apiV2.post<{ data: ExportFile }>('/admin/exports/cares', {
      year,
      only_active: onlyActive,
    });
    return res.data.data;
  },

  /** Lädt die fertige Datei als Blob und stößt den Browser-Download an. */
  download: async (exportFile: ExportFile): Promise<void> => {
    const res = await apiV2.get(`/admin/exports/${exportFile.id}/download`, {
      responseType: 'blob',
      timeout: 120000,
    });

    const url = URL.createObjectURL(res.data as Blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = exportFile.file;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  },
};
